import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormBuilder, FormControl } from '@angular/forms';
import { templateSuccess } from '../../constants/templateSuccess';
import { StepperService } from '@core/stepper/stepper.service';
import { TooltipInfoTableAfsReviewService } from '@core/messages/tooltip-info-table-afs-review.service';
import smoothscroll from 'smoothscroll-polyfill';

interface Combobox {
  id: number;
  name: string;
}

interface UpdateActionPlanTableElement {
  item_id: number;
  finding: string;
  recommendation: string;
  comments: string;
  actionsDE: Array<string>;
  responsable: string;
  estimatedID: string;
  meansV: any;
}

@Component({
  selector: 'bid-update-action-plan-table',
  templateUrl: './update-action-plan-table.component.html',
  styleUrls: ['./update-action-plan-table.component.scss'],
})
export class UpdateActionPlanTableComponent implements OnInit {
  @Input() headerTable;
  @Input() editable;
  @Input() scoreScreen = false;
  @Output() sendStatus = new EventEmitter<string>();
  @Input() tableButtons = true;
  @Input() analysisId;
  @Input() language;
  disabledButton: boolean;
  templateSuccess = templateSuccess;
  actions: Combobox[];
  selectedAction: Combobox;
  status: Combobox[];
  selectedStatus: Combobox;
  selectFile: boolean;
  VOForm: FormGroup;
  isEditableNew = false;
  estimateDate: FormGroup;
  displayModal: boolean;
  dataSource: any;
  ELEMENT_DATA: UpdateActionPlanTableElement[] = [];
  public states: any[] = [
    {
      id: 1,
      name: 'Pendiente',
    },
    {
      id: 1,
      name: 'En proceso',
    },
    {
      id: 1,
      name: 'Finalizado',
    },
  ];
  itemOption = new FormControl('In process');

  STEP2 = [
    { name: 'loadActionPlan', stepSelected: false },
    { name: 'updateActionPlan', stepSelected: true },
    { name: 'myActionPlan', stepSelected: false },
  ];

  displayedColumns: string[] = [
    'item_id',
    'finding',
    'recommendation',
    'comments',
    'actionsDE',
    'responsable',
    'estimatedID',
    'meansV',
  ];

  constructor(
    private fb: FormBuilder,
    private _formBuilder: FormBuilder,
    private stepperService: StepperService,
    private tooltipInfoTableAfsReviewService: TooltipInfoTableAfsReviewService,
  ) {
    this.allOptionsCombobox();
    this.allRows();
    const today = new Date();
    this.estimateDate = new FormGroup({
      start: new FormControl(new Date(today.getFullYear(), today.getMonth(), 13)),
      itemOption: new FormControl('In process'),
    });
  }

  ngOnInit() {
    this.VOForm = this._formBuilder.group({
      VORows: this._formBuilder.array([]),
    });

    this.disabledButton = true;

    this.dataSource = this.ELEMENT_DATA;
    this.stepperService.setStepper(this.STEP2);
  }

  allRows() {
    this.ELEMENT_DATA = [
      {
        item_id: 1,
        finding: `Error en el objeto de la resolución de apertura del concurso de méritos para selección de
        Interventoría.
        En nuestra revisión de contratos suscritos con recursos de Contrapartida, observamos que el contrato
        de interventoría 00...`,
        recommendation: `Se recomienda al Ente Gestor, realizar una correcta aplicación de la Ley 80, Ley 1150 y sus
        modificaciones donde se detalla paso a paso los requisitos establecidos para cada tipo de contratación,
        así mismo...`,
        comments: `nes donde se detalla paso a paso los requisitos establecidos para cada tipo de contratación,
        así mismo...`,
        actionsDE: [
          `Como medida preventiva se implementará un control de revisión previo a la firma de `,
          `Como medida preventiva se implementará un control de revisión previo a la firma de `,
        ],
        responsable: 'Contabilidad',
        estimatedID: '14/12/21',
        meansV: 'In process',
      },
      {
        item_id: 2,
        finding: `Error en el objeto de la resolución de apertura del concurso de méritos para selección de
        Interventoría.
        En nuestra revisión de contratos suscritos con recursos de Contrapartida, observamos que el contrato
        de interventoría 00...`,
        recommendation: `Se recomienda al Ente Gestor, realizar una correcta aplicación de la Ley 80, Ley 1150 y sus
        modificaciones donde se detalla paso a paso los requisitos establecidos para cada tipo de contratación,
        así mismo...`,
        comments: `nes donde se detalla paso a paso los requisitos establecidos para cada tipo de contratación,
        así mismo...`,
        actionsDE: [
          `Como medida preventiva se implementará un control de revisión previo a la firma de `,
          `Como medida preventiva se implementará un control de revisión previo a la firma de `,
        ],
        responsable: 'Área de Gestión Jurídica',
        estimatedID: '14/12/21',
        meansV: 'In process',
      },
      {
        item_id: 3,
        finding: `Error en el objeto de la resolución de apertura del concurso de méritos para selección de
        Interventoría.
        En nuestra revisión de contratos suscritos con recursos de Contrapartida, observamos que el contrato
        de interventoría 00...`,
        recommendation: `Se recomienda al Ente Gestor, realizar una correcta aplicación de la Ley 80, Ley 1150 y sus
        modificaciones donde se detalla paso a paso los requisitos establecidos para cada tipo de contratación,
        así mismo...`,
        comments: `nes donde se detalla paso a paso los requisitos establecidos para cada tipo de contratación,
        así mismo...`,
        actionsDE: [
          `Como medida preventiva se implementará un control de revisión previo a la firma de `,
          `Como medida preventiva se implementará un control de revisión previo a la firma de `,
        ],
        responsable: 'Contabilidad',
        estimatedID: '14/12/21',
        meansV: 'In process',
      },
    ];
  }

  allOptionsCombobox() {
    this.actions = [
      {
        id: 1,
        name: 'Como medida preventiva se implementará un control de revisión previo a la firma de',
      },
      {
        id: 2,
        name: 'Como medida preventiva se implementará un control de revisión previo a la firma de',
      },
    ];
    this.status = [
      { id: 1, name: 'Pendiente' },
      { id: 2, name: 'En proceso' },
      { id: 3, name: 'Finalizado' },
    ];
  }

  isSelectFile() {
      this.selectFile = !this.selectFile;

  }

  showModalDialog() {
    this.displayModal = true;
  }

  myFilter = (d: Date | null): boolean => {
    const day = (d || new Date()).getDay();
    return day !== 0 && day !== 6;
  };

  backToTop() {
    smoothscroll.polyfill();
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  }
}
